import * as AK from '@ariakit/react'
import {Button} from '../controls/Button'

export interface SubmitProps extends AK.FormSubmitProps {}

export const Submit = (props: SubmitProps) => (
  <AK.FormSubmit render={<Button variant="primary" />} {...props} />
)
